export const timestamper = (signatureHex, callback, fail) => {
  fetch(`${process.env.REACT_APP_SOLIQ_BASE_URL}/provider/api/utils/timestamp?signatureHex=${signatureHex}`, {
    method: 'GET',
  }).then((r) => {
    r.json().then((data) => {
      callback(data.data);
    });
  });
};
